import styled from 'styled-components';
import { Typ20, Typ35 } from 'dc/Typ';
import { Ico16 } from 'dc/Ico';
import Load04 from 'dc/Load04';

type ContainerProps = {
  isHighlighted?: boolean;
  canClick?: boolean;
};

export const Container = styled.div<ContainerProps>`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  background: ${props => (props.isHighlighted ? '#DCEDC8' : '#F4F7F9')};
  border: 1px solid ${props => (props.isHighlighted ? '#DCEDC8' : '#F4F7F9')};
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 24px;
  cursor: ${props => (props.canClick ? 'pointer' : 'default')};
  ${props =>
    props.canClick &&
    `&:hover {
    border: 1px solid #007079;
  }`};
`;

type NumberWrapperProps = {
  backgroundColor?: string;
};

export const NumberWrapper = styled.div<NumberWrapperProps>`
  height: 24px;
  width: 24px;
  border-radius: 50%;
  background: ${props =>
    props.backgroundColor ? props.backgroundColor : '#0099A9'};
  margin-right: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Number = styled(Typ20)`
  color: #fff;
`;

export const Icon = styled(Ico16)``;

export const Loader = styled(Load04)`
  margin-right: 16px;
`;

export const Answer = styled(Typ35)``;
